import { AIModelType } from "@/api";
import { FormSelectElement } from "@rhf-kit/mui";

/**
 * Select for the AI model type.
 */
export const AIModelSelect = () => {
    const options = Object.values(AIModelType).map((value) => ({
        label: value === AIModelType.CHATGPT ? `${value} (recommended)` : value,
        value,
    }));

    return (
        <FormSelectElement
            label="Model Type"
            name="modelType"
            helperText="The type of model to use for AI processing."
            options={options}
            disabled
        />
    );
};
